var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"role":"link","color":_vm.component.button_color ? _vm.component.button_color.hex : 'primary'},on:{"click":function($event){if (_vm.component.component_default_value) {
                _vm.openInNewTab(_vm.component.component_default_value, _vm.component.is_open_on_tab);
            }}}},[_vm._v(" "+_vm._s(_vm.component.component_label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }